import React from 'react';
import { Route } from 'react-router-dom';
import NotFoundScreen from '../404';
import DocumentationScreen from './index';

const documentationRoute = ({ enabled, isBrandUser, isWhitelabel }) => (
  <Route
    exact
    path={['/documentation', '/documentation/:slug']}
    render={routeProps =>
      enabled ? (
        <DocumentationScreen {...routeProps} isBrandUser={isBrandUser} isWhitelabel={isWhitelabel} />
      ) : (
        <NotFoundScreen isWhitelabel={isWhitelabel} />
      )
    }
  />
);

export default documentationRoute;
